// src/common/components/cartModal/hooks/usePaymasterPayment.ts
import { useEffect, useState, useCallback, useRef } from "react"
import { PaymasterStage } from "../../../../types/enums"

interface UsePaymasterPaymentProps {
  onSuccess?: () => void
  onError?: () => void
}

export const usePaymasterPayment = (
  paymentUrl: string,
  { onSuccess, onError }: UsePaymasterPaymentProps = {},
) => {
  const [stage, setStage] = useState<PaymasterStage>(PaymasterStage.PAYMENT)
  const iframeRef = useRef<HTMLIFrameElement | null>(null)

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== "https://paymaster.ru") return

      if (event.data?.method === "handleStatus") {
        const status = event.data?.params?.[0]?.status
        if (status === "success") {
          setStage(PaymasterStage.SUCCESS)
          onSuccess?.()
        } else if (status === "failed") {
          setStage(PaymasterStage.ERROR)
          onError?.()
        }
      }

      if (event.data?.method === "handlePaymentLink") {
        const paymentLink = event.data?.params?.[0]?.paymentLink?.payload
        if (paymentLink) {
          window.open(paymentLink, "_blank")
        }
      }
    },
    [onSuccess, onError],
  )

  useEffect(() => {
    window.addEventListener("message", handleMessage)
    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [handleMessage])

  return { stage }
}